import { graphql } from "@generated/client";
import {
    ActivateModuleInput,
    DeactivateModuleInput,
    GetModuleConfigBackOfficeQueryVariables,
} from "@generated/client/graphql";
import { AccessHeadersHolder } from "../AccessHeadersHolder";
import { graphqlClientKoyeb } from "../clients";

const GetModuleConfigBackOffice = graphql(`
    query GetModuleConfigBackOffice($tenantId: String!) {
        moduleConfigBackOffice(input: { tenantId: $tenantId }) {
            moduleId
            name
            moduleType
            productType
            isActive
            addOns {
                moduleId
                name
                moduleType
                productType
                isActive
            }
        }
    }
`);

const GetModuleConfig = graphql(`
    query GetModuleConfig {
        moduleConfig {
            moduleId
            name
            moduleType
            productType
            isActive
            addOns {
                moduleId
                name
                moduleType
                productType
                isActive
            }
        }
    }
`);

const ActivateModule = graphql(`
    mutation ActivateModule($input: ActivateModuleInput!) {
        activateModule(input: $input) {
            status
        }
    }
`);

const DeactivateModule = graphql(`
    mutation DeactivateModule($input: DeactivateModuleInput!) {
        deactivateModule(input: $input) {
            status
        }
    }
`);

export class GraphQLModuleConfigurationRepository {
    getModuleConfigBackOffice = async (
        input: GetModuleConfigBackOfficeQueryVariables,
    ) =>
        graphqlClientKoyeb.request(
            GetModuleConfigBackOffice,
            input,
            await AccessHeadersHolder.getHeaders(),
        );

    getModuleConfig = async () =>
        graphqlClientKoyeb.request(
            GetModuleConfig,
            undefined,
            await AccessHeadersHolder.getHeaders(),
        );

    activateModule = async (input: ActivateModuleInput) =>
        graphqlClientKoyeb.request(
            ActivateModule,
            { input },
            await AccessHeadersHolder.getHeaders(),
        );

    deactivateModule = async (input: DeactivateModuleInput) =>
        graphqlClientKoyeb.request(
            DeactivateModule,
            { input },
            await AccessHeadersHolder.getHeaders(),
        );
}
